import { Context, type Effect, Layer, type Scope } from "effect";
import type { ModalFocusCallbacks, ModalFocusFailure } from "./modal-focus-model.ts";

export class ModalFocusIo extends Context.Service<ModalFocusIo, {
  readonly watch: (input: ModalFocusCallbacks, canRead: () => boolean, report: (failure: ModalFocusFailure) => void) => Effect.Effect<void, ModalFocusFailure, Scope.Scope>;
  readonly trap: (target: HTMLElement | null, input: ModalFocusCallbacks, canRead: () => boolean, report: (failure: ModalFocusFailure) => void) => Effect.Effect<void, ModalFocusFailure, Scope.Scope>;
}>()("workerstation/frontend/ModalFocusIo") {}
export const ModalFocusIoTest = (io: typeof ModalFocusIo.Service) => Layer.succeed(ModalFocusIo, io);
export interface ModalFocusSession {
  readonly receive: (open: boolean, target: HTMLElement | null) => Effect.Effect<void>;
}
export class ModalFocusSessions extends Context.Service<ModalFocusSessions, {
  readonly open: (input: ModalFocusCallbacks) => Effect.Effect<ModalFocusSession, never, Scope.Scope>;
}>()("workerstation/frontend/ModalFocusSessions") {}
